import React from "react"
import ReactTooltipTrigger from '../../../components/ReactTooltipTrigger'

export default function PartnersAgreement(props) {
  return (
    <div className="form-checkbox-row">
      <div className="checkbox">
        <label>
          <input type="checkbox" checked={props.checked} onChange={props.onChange} />
          {I18n.t("fe.partners_agreement.label")}
          <ReactTooltipTrigger tooltip={I18n.t("fe.partners_agreement.tooltip")}>
            <i className="info-icon"></i>
          </ReactTooltipTrigger>
          <span> *</span>
        </label>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/PartnersAgreement.jsx